// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2B__z","label":"styles_label__30wFs"};